import { render } from "./StripePaymentElement.vue?vue&type=template&id=480b94a4&scoped=true"
import script from "./StripePaymentElement.vue?vue&type=script&lang=js"
export * from "./StripePaymentElement.vue?vue&type=script&lang=js"

import "./StripePaymentElement.vue?vue&type=style&index=0&id=480b94a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480b94a4"]])

export default __exports__